import { BehaviorSubject, Observable, filter, share, switchMap } from 'rxjs';
import { name } from './channels';
import { client } from './client';
import { Subscriptions } from './subscriptions';
import { recordMainThreadChannels, recordMainThreadMessage } from './telemetry';
const subscriptions = new BehaviorSubject(Subscriptions.empty());
const subs = ()=>subscriptions.value;
export const pushes = (info, [action, type])=>client().pipe(switchMap((pusher)=>new Observable((subscriber)=>{
            const channel_name = name(info);
            const channel = pusher.subscribe(channel_name);
            const handler = subscriber.next.bind(subscriber);
            const trackedHandler = (data)=>{
                recordMainThreadMessage();
                handler(data);
            };
            channel.bind(action, trackedHandler);
            subscriptions.next(Subscriptions.add(subs(), channel_name));
            recordMainThreadChannels(Subscriptions.activeCount(subs()));
            return ()=>{
                channel.unbind(action, trackedHandler);
                subscriptions.next(Subscriptions.remove(subs(), channel_name));
                recordMainThreadChannels(Subscriptions.activeCount(subs()));
                if (Subscriptions.has_none(subs(), channel_name)) {
                    pusher.unsubscribe(channel_name);
                }
            };
        })), filter(({ objectType })=>objectType === type), share());
